import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ConsultationEditPage = lazy(() =>
  import("./pages/ConsultationEditPage").then((m) => ({ default: m.ConsultationEditPage }))
);
const ConsultationNewForPatientPage = lazy(() =>
  import("./pages/ConsultationNewForPatientPage").then((m) => ({
    default: m.ConsultationNewForPatientPage,
  }))
);

export const consultationsRoutes: RouteObject[] = [
  {
    path: "new/:patientId",
    element: <ConsultationNewForPatientPage />,
  },
  {
    path: ":id/edit",
    element: <ConsultationEditPage />,
  },
];
